// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"acfd1ddf","1201":"b4e65240","2342":"6463262c","9842":"acfd1ddf"}[chunkId] + ".chunk.css";
};